/*
═══════════════════════════════════════════════════════════
НАСТРОЙКА НА ЯСНОСТЬ / CLARITY
═══════════════════════════════════════════════════════════
Автор: @Elena_evolvecode
Telegram: @na_sh_kodila
Создано: 2025-2026
Все права защищены
═══════════════════════════════════════════════════════════
*/

import React, { useState } from 'react';
import PrivacyModal from './PrivacyModal';

const Footer = () => {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  return (
    <>
      <footer style={styles.footer}>
        <p style={styles.copyright}>Настройка на ясность / 2026</p>
        <div style={styles.links}>
          <a
            href="https://t.me/na_sh_kodila"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            ТГ канал автора
          </a>
          <span style={styles.divider}>•</span>
          <button
            style={styles.linkButton}
            onClick={() => setIsPrivacyOpen(true)}
          >
            Приватность
          </button>
        </div>
      </footer>

      <PrivacyModal
        isOpen={isPrivacyOpen}
        onClose={() => setIsPrivacyOpen(false)}
      />
    </>
  );
};

const styles = {
  footer: {
    textAlign: 'center',
    padding: '32px 20px',
    marginTop: '40px',
    borderTop: '1px solid rgba(229, 210, 160, 0.1)',
  },
  copyright: {
    color: 'rgba(255, 255, 255, 0.4)',
    fontSize: '12px',
    marginBottom: '12px',
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
  },
  link: {
    color: 'rgba(229, 210, 160, 0.6)',
    fontSize: '12px',
    textDecoration: 'none',
  },
  linkButton: {
    background: 'none',
    border: 'none',
    color: 'rgba(229, 210, 160, 0.6)',
    fontSize: '12px',
    cursor: 'pointer',
    padding: 0,
  },
  divider: {
    color: 'rgba(255, 255, 255, 0.2)',
    fontSize: '12px',
  },
};

export default Footer;
